import { usePersistentState } from '../../lib/hooks/index.js'
import './CollapsiblePanel.css'

// Left panel that slides away. The toggle tab stays outside the inert content
// so the panel can always be reopened; collapsed state persists per storageKey.
export function CollapsiblePanel({ storageKey, width = 256, children }) {
  const [collapsed, setCollapsed] = usePersistentState(storageKey, false)

  return (
    <div className={`collapsible-panel ${collapsed ? 'collapsed' : ''}`} style={{ '--panel-width': `${width}px` }}>
      <div className="collapsible-panel-slide">
        <div className="collapsible-panel-content" inert={collapsed}>{children}</div>
        <button
          className="collapsible-panel-toggle"
          onClick={() => setCollapsed(v => !v)}
          title={collapsed ? 'Expand panel' : 'Collapse panel'}
        >
          {collapsed ? '›' : '‹'}
        </button>
      </div>
    </div>
  )
}
